import { ReactNode } from 'react';
import classNames from 'classnames';
import 'app/agriculture/components/SimpleGrid/SimpleGrid.scss';

interface SimpleGridProps {
    children: ReactNode;
    className?: string;
    columns?: number;
    gap?: number;
}

export function SimpleGrid({ children, className, columns = 1, gap = 24 }: SimpleGridProps) {
    return (
        <div
            className={classNames('SimpleGrid', className)}
            style={{ '--columns': columns, '--gap': gap }}
        >
            {children}
        </div>
    );
}
